import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-transparent rounded-full flex items-center justify-center shadow-large">
              <img src={`${import.meta.env.BASE_URL}/assets/icon.png`.replace('//', '/')} alt="BravoSim" className="w-20 h-20" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            BravoSim
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Simulação Inteligente
          </p>
        </div>
        <Outlet />
        <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-8">
          © 2025 BravoSim - Todos os direitos reservados
        </p>
      </div>
    </div>
  )
}
